var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-card", { staticClass: "mb-4", attrs: { id: _vm.userId } }, [
    _c("div", { staticClass: "main-block" }, [
      _c("div", { staticClass: "media-block" }, [
        _c("img", {
          staticClass: "search-photo mb-3",
          class: { clickable: !_vm.searchDisabled },
          attrs: { src: _vm.photo },
          on: { click: _vm.profNameClick }
        }),
        _vm._v(" "),
        _vm.rating.total > 0
          ? _c("div", [
              _c(
                "div",
                { staticClass: "rating" },
                [
                  _vm._l(5, function(n) {
                    return _c(
                      "span",
                      { key: "rating-" + n },
                      [
                        _c(_vm.ratingComponent(n), {
                          tag: "component",
                          attrs: { "font-scale": "1.3" }
                        }),
                        _vm._v(" \n          ")
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  !_vm.xlScreen
                    ? _c("span", {
                        staticClass: "rating-mobile",
                        domProps: {
                          innerHTML: _vm._s("(" + _vm.rating.total + ")")
                        }
                      })
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.xlScreen
                ? _c("label", {
                    staticClass: "califications",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.rating.total + " " + _vm.$t("ratings")
                      )
                    }
                  })
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isProfUser && _vm.userLoggedIsPatient
          ? _c(
              "div",
              { staticClass: "favourite", on: { click: _vm.toggleFavourite } },
              [
                _vm.isFavourite
                  ? _c(
                      "span",
                      [
                        _c("b-icon-heart-fill"),
                        _vm._v(" " + _vm._s(_vm.$t("removeOfMyTeam")))
                      ],
                      1
                    )
                  : _c(
                      "span",
                      [
                        _c("b-icon-heart", { staticClass: "blue" }),
                        _vm._v(" " + _vm._s(_vm.$t("addToMyTeam")))
                      ],
                      1
                    )
              ]
            )
          : !_vm.isProfUser
          ? _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c(
                  "base-button",
                  { attrs: { white: "" }, on: { click: _vm.showCenterProfs } },
                  [_vm._v(_vm._s(_vm.$t("showProfessionals")))]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info-block" },
        [
          _c("div", [
            _c(
              "span",
              {
                staticClass: "search-name",
                class: { clickable: !_vm.searchDisabled },
                on: { click: _vm.profNameClick }
              },
              [
                _vm._v(
                  _vm._s(
                    "" + _vm.name + (_vm.surnames ? " " + _vm.surnames : "")
                  )
                )
              ]
            ),
            _vm._v(" "),
            _vm.showProfLogo
              ? _c("img", {
                  staticClass: "prof-logo ml-3",
                  attrs: {
                    src: _vm.unipromelImg,
                    title: _vm.$t("unipromelPopover")
                  },
                  on: { click: _vm.logoClick }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.specialtiesToShow.length > 0
            ? _c(
                "ul",
                { staticClass: "specialties-list mt-2" },
                _vm._l(_vm.specialtiesToShow, function(item) {
                  return _c(
                    "li",
                    _vm._g(
                      {
                        key: item.id,
                        staticClass: "mr-3 mb-3",
                        class: item.id === -1 ? "clickable" : null,
                        domProps: {
                          innerHTML: _vm._s(
                            "" +
                              (item.id === -1
                                ? item.name
                                : _vm.$i18nHelpers.normalize(item.name))
                          )
                        }
                      },
                      item.id === -1 ? { click: _vm.showMoreSpecialties } : {}
                    )
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.subspecialtiesToShow.length > 0
            ? _c(
                "ul",
                { staticClass: "subspecialties-list" },
                [
                  _c("b", { staticClass: "inline-block mr-3 mb-3" }, [
                    _vm._v(_vm._s(_vm.$t("specialistInSearh")))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.subspecialtiesToShow, function(item) {
                    return _c(
                      "li",
                      _vm._g(
                        {
                          key: item.id,
                          staticClass: "mr-3 mb-3",
                          class: item.id === -1 ? "clickable" : null,
                          domProps: {
                            innerHTML: _vm._s(
                              "" +
                                (item.id === -1
                                  ? item.name
                                  : _vm.$i18nHelpers.normalize(item.name))
                            )
                          }
                        },
                        item.id === -1
                          ? { click: _vm.showMoreSubspecialties }
                          : {}
                      )
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.introductoryText
            ? _c("p", {
                staticClass: "introductory-text",
                domProps: { innerHTML: _vm._s(_vm.introductoryText) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.centersToShow && _vm.centersToShow.length > 0
            ? _c(
                "div",
                { staticClass: "mb-3" },
                [
                  _vm._l(_vm.centersToShow, function(item) {
                    return _c(
                      "div",
                      { key: item.id },
                      [
                        _c("b-icon-geo-alt-fill", { staticClass: "blue" }),
                        _vm._v(" "),
                        item.customPageUrl
                          ? _c("a", {
                              staticClass: "bold",
                              attrs: {
                                href: _vm.$helpers.getCustomPageUrl(
                                  item.customPageUrl
                                ),
                                target: "_blank"
                              },
                              domProps: {
                                innerHTML: _vm._s(
                                  "" +
                                    (item.town || item.province
                                      ? (item.town || item.province) + ": "
                                      : "") +
                                    item.center
                                )
                              }
                            })
                          : _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  "" +
                                    (item.town || item.province
                                      ? (item.town || item.province) + ": "
                                      : "") +
                                    item.center
                                )
                              }
                            })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.showMoreCentersBtn
                    ? _c("div", {
                        staticClass: "show-more-centers",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("show") +
                              " " +
                              (_vm.centers.length - 1) +
                              " " +
                              _vm.$t("moreCenters")
                          )
                        },
                        on: { click: _vm.showMoreCenters }
                      })
                    : _vm._e()
                ],
                2
              )
            : _vm.centerTown
            ? _c("div", { staticClass: "mb-3" }, [
                _c(
                  "div",
                  [
                    _c("b-icon-geo-alt-fill", { staticClass: "blue" }),
                    _vm._v(" "),
                    _vm.centerTown.name
                      ? _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.centerTown.name +
                                " (" +
                                _vm.centerTown.province +
                                ")"
                            )
                          }
                        })
                      : _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("noPhysicalLocation"))
                          }
                        })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "languages-list" },
            _vm._l(_vm.languagesToShow, function(item) {
              return _c("li", { key: item.code, staticClass: "mr-3 mb-3" }, [
                _c(
                  "span",
                  _vm._g(
                    {
                      class: item.code === -1 ? "clickable" : null,
                      domProps: { innerHTML: _vm._s(item.language) }
                    },
                    item.code === -1 ? { click: _vm.showMoreLanguages } : {}
                  )
                )
              ])
            }),
            0
          ),
          _vm._v(" "),
          _vm.attendInsurance
            ? _c(
                "div",
                { staticClass: "mb-5" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: {
                        transparent: "",
                        borderColor: _vm.GRAY_COLOUR,
                        textColor: _vm.GRAY_COLOUR
                      },
                      on: { click: _vm.getInsurers }
                    },
                    [_vm._v(_vm._s(_vm.$t("showInsurances")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userLoggedIsProf
            ? _c(
                "div",
                { staticClass: "mt-4" },
                [_c("search-blocks-professional")],
                1
              )
            : _c(
                "div",
                { staticClass: "service-type mt-4" },
                [
                  _vm._l(_vm.servicesToShow, function(item, index) {
                    return _c("search-service-type-block", {
                      key: "service-block-" + index,
                      attrs: {
                        price: _vm.getServicePrice(item.id, item.rate),
                        serviceType: item.id,
                        firstAppointmentPrice: _vm.firstAppointmentPrice(
                          item.id,
                          item.firstConsultationPrice
                        ),
                        nextAvailability: _vm.nextAvailability(item.id),
                        requestAppointmentTitle: _vm.requestAppointmentTitle(
                          item.id
                        ),
                        action: _vm.isProfUser
                          ? function() {
                              return _vm.serviceAction(item.id)
                            }
                          : function() {
                              return _vm.centerServiceAction(item.id)
                            },
                        includedInCompanyService: _vm.includedInCompanyService(
                          item.id
                        ),
                        includedInSubscription: _vm.includedInSubscription(
                          item.id
                        ),
                        specialCompanyPrice: _vm.specialCompanyPrice(item.id),
                        showOnlyBySubscription: _vm.showOnlyBySubscription(
                          item.id
                        ),
                        copaymentPrice: _vm.copaymentPrice(item.id),
                        opensaludpassActive: _vm.opensaludpassActive,
                        ratesRangeActive: _vm.ratesRangeActive(item.id)
                      }
                    })
                  }),
                  _vm._v(" "),
                  _vm.showBudget
                    ? _c("search-service-type-block", {
                        attrs: {
                          budget: "",
                          requestAppointmentTitle: _vm.$t("request"),
                          action: _vm.budgetAction
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.diagnosticsTestsBlock
                    ? _c("search-service-type-block", {
                        attrs: {
                          tests: "",
                          requestAppointmentTitle: _vm.$t("request"),
                          action: _vm.testsAction
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showDefaultBlock &&
                  (!_vm.xsScreen || _vm.servicesToShow.length < 2)
                    ? _c("search-service-type-block", {
                        attrs: {
                          requestAppointmentTitle: _vm.defaultServiceTitle,
                          showingMoreServices: _vm.servicesToShow.length > 0,
                          default: "",
                          action: _vm.defaultServiceAction
                        }
                      })
                    : _vm._e()
                ],
                2
              ),
          _vm._v(" "),
          _vm.showDefaultBlock && _vm.xsScreen && _vm.servicesToShow.length >= 2
            ? _c("search-service-type-block", {
                staticClass: "mt-4",
                staticStyle: { "max-width": "100%" },
                attrs: {
                  showingMoreServices: _vm.servicesToShow.length > 0,
                  default: "",
                  hideIcon: "",
                  action: _vm.defaultServiceAction
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47cf652a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47cf652a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/search/SearchBlock.vue
// module id = 2970
// module chunks = 11 48